
import { throwError as observableThrowError, Observable, Subscription, BehaviorSubject } from 'rxjs';

import { catchError, filter, finalize, switchMap, take, retry, map } from 'rxjs/operators';
import { Injectable, Component } from "@angular/core";
import { Inject } from '@angular/core';
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";
import { Urls } from '../../../environments/environment';
import { DataConfig, routePaths } from "../config";
import { AuthService } from "../authentication/authentication.servicie";
import { Router } from "@angular/router";
import { GOOGLE_LOGIN_CONFIG, GoogleLoginConfig, GoogleLoginService } from '@chalo/chalo-angular-login-libraries';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { LocalStorageService } from './local-storage.service';
import { googleConfig } from '../../../environments/environment';
import * as jwt_decode from "jwt-decode";


@Injectable()
export class RestApiCall {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  checkStatus: boolean = false;
  mygetMethodSubscription: Subscription;
  firstCall: boolean = false;
  cities: Array<any> = [];
  searchedKeyword: string = "";
  userName: any;
  public dataObsevable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    this.checkStatus
  );
  constructor(
    @Inject(GOOGLE_LOGIN_CONFIG) private config: GoogleLoginConfig,
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private _localStorage: LocalStorageService,
    private googleLoginService: GoogleLoginService<any>,
    private storage: LocalStorageService
  ) {
    this.getCities();
  }
  private getRegionFromUrl(): string {
    const url = window.location.href;

    if (url.includes('tsrtc') || url.includes('tgsrtc')) {
      return 'TSRTC';
    }
    if (url.includes('ksrtc')) {
      return 'KSRTC';
      
    }
    if (url.includes('crut')) {
      return 'CRUT';
    }
    return 'OTHERS';
  }


  /**
   *  Make an api call for fetching stats from the url
   *@returns {Observable<R>} returns Observable
   */
  get(url, params, responseType?: any): Observable<any> {
    //debugger
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    if (params == null) {
      return this.http
        .get(url, { headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .get(url, { params, headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }

  getWithRegionId(url, params, responseType?: any): Observable<any> {
    //debugger
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);

    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    headers = headers.set("regionId", '1');
    if (params == null) {
      return this.http
        .get(url, { headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .get(url, { params, headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }

  getFieldAudit(url, params, responseType?: any): Observable<any> {
    //debugger
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    headers = headers.set("regionId", this.getRegionFromUrl())
    if (params == null) {
      return this.http
        .get(url, { headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .get(url, { params, headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }

  // get3(url, params,responseType?:any): Observable<any> {
  // 	//debugger
  // 	let headers = new HttpHeaders();
  // 	if (this.authService.token) {
  // 		headers = headers.set('Authorization', this.authService.token)
  // 	}
  // 	headers = headers.set('X-Timezone-Offset', String( (new Date().getTimezoneOffset())*(-1)  ));
  // 	if (params == null) {
  // 		return this.http.get(url, { headers ,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	} else {
  // 		return this.http.get(url, { params, headers,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	}
  // }

  get3(
    url: string,
    params: HttpParams | null,
    responseType?: any
  ): Observable<any> {
    let headers = new HttpHeaders();

    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
    }

    headers = headers.set(
      "X-Timezone-Offset",
      String(new Date().getTimezoneOffset() * -1)
    );

    let options = {
      headers,
      responseType,
    };

    if (params !== null) {
      options["params"] = params;
    }

    return this.http
      .get(url, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  // get2(url, params,responseType?:any): Observable<any> {
  // 	//debugger
  // 	let headers = new HttpHeaders();
  // 	if (this.authService.token) {
  // 		headers = headers.set('Authorization', this.authService.token)
  // 	}
  // 	if (params == null) {
  // 		return this.http.get(url, { headers ,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	} else {
  // 		return this.http.get(url, { params, headers,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	}
  // }

  get2(
    url: string,
    params: HttpParams | null,
    responseType?: any
  ): Observable<any> {
    let headers = new HttpHeaders();

    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
    }

    let options = {
      headers,
      responseType,
    };

    if (params !== null) {
      options["params"] = params;
    }

    return this.http
      .get(url, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  getStatus(url): Observable<any> {
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.append("Authorization", this.authService.token);
    }
    headers = headers.append("X-Timezone-Offset", this.getTimezoneOffset());
    return this.http
      .get(url, { headers })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  getforChalo(url, params, responseType?: any): Observable<any> {
    //debugger

    let headers = new HttpHeaders();
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    if (params == null) {
      return this.http
        .get(url, { headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .get(url, { params, headers: headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }

  getforChalo2(url, params, responseType?: any): Observable<any> {
    //debugger

    let headers = new HttpHeaders();
    if (params == null) {
      return this.http
        .get(url, { headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .get(url, { params, headers: headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }

  getforChaloScheduler(url, params, responseType?: any): Observable<any> {
    //debugger

    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.append("Authorization", this.authService.token);
    }
    if (params == null) {
      return this.http
        .get(url, { headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .get(url, { params, headers: headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }
  /**
   *  Make an api call for fetching stats from the url
   *@returns {Observable<R>} returns Observable
   */
  // getUserUnder(url, params,responseType?:any): Observable<any> {
  // 	let headers = new HttpHeaders();
  // 	// if (this.authService.token) {
  // 	// 	headers.append('Authorization', this.authService.token)
  // 	// }
  // 	headers = headers.set('X-Timezone-Offset', this.getTimezoneOffset());
  // 	if (params == null) {
  // 		return this.http.get(url, { headers: headers ,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	} else {
  // 		return this.http.get(url, { params, headers: headers,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	}
  // }

  getUserUnder(
    url: string,
    params: HttpParams | null,
    responseType?: any
  ): Observable<any> {
    let headers = new HttpHeaders();

    // Commented out the authorization header
    // if (this.authService.token) {
    //   headers = headers.append('Authorization', this.authService.token);
    // }

    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    let options = {
      headers,
      responseType,
    };

    if (params !== null) {
      options["params"] = params;
    }

    return this.http
      .get(url, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  /**
   *  Make an api call for fetching stats from the url
   *@returns {Observable<R>} returns Observable
   */

  // getUserUnderAgency(url, params,responseType?:any): Observable<any> {
  // 	//debugger;
  // 	let headers = new HttpHeaders();
  // 	// if (this.authService.token) {
  // 	// 	headers.append('Authorization', this.authService.token)
  // 	// }
  // 	headers = headers.set('X-Timezone-Offset', this.getTimezoneOffset());
  // 	if (params == null) {
  // 		return this.http.get(url, { headers: headers ,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	} else {
  // 		return this.http.get(url, { params, headers: headers,responseType:responseType })
  // 			.map(this.extractData.bind(this))
  // 			.catch(this.handleError.bind(this));
  // 	}
  // }

  getUserUnderAgency(
    url: string,
    params: HttpParams | null,
    responseType?: any
  ): Observable<any> {
    let headers = new HttpHeaders();

    // Commented out the authorization header
    // if (this.authService.token) {
    //   headers = headers.append('Authorization', this.authService.token);
    // }

    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    let options = {
      headers,
      responseType,
    };

    if (params !== null) {
      options["params"] = params;
    }

    return this.http
      .get(url, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  // post(url, data): Observable<any> {
  // 	//debugger;
  // 	let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  // 	if (this.authService.token) {
  // 		headers = headers.set('Authorization', this.authService.token);
  // 		headers = headers.set('Access-Control-Expose-Headers', 'Authorization');
  // 	}
  // 	headers = headers.set('X-Timezone-Offset', this.getTimezoneOffset());
  // 	let options = { headers: headers };

  // 	return this.http.post(url, data, options)
  // 		.map(this.extractData.bind(this))
  // 		.catch(this.handleError.bind(this));
  // }
  postWithParams(url: string, data: any, params: HttpParams): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });

    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }

    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    let options = { headers, params };

    return this.http
      .post(url, data, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }
  post(url: string, data: any): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });

    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }

    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    let options = { headers };

    return this.http
      .post(url, data, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  // postEtim(url, data, responseType?:any): Observable<any> {
  // 	let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  // 	if (this.authService.token) {
  // 		headers = headers.set('Authorization', this.authService.token);
  // 		headers = headers.set('Access-Control-Expose-Headers', 'Authorization');
  // 	}
  // 	headers = headers.set('X-Timezone-Offset', this.getTimezoneOffset());
  // 	let options = { headers: headers, responseType: responseType };

  // 	return this.http.post(url, data, options)
  // 		.map(this.extractData.bind(this))
  // 		.catch(this.handleError.bind(this));
  // }

  postEtim(url: string, data: any, responseType?: any): Observable<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }

    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    let options = { headers, responseType };

    return this.http
      .post(url, data, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  // postSSO(url, params): Observable<any> {
  // 	let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  // 	if (this.authService.token) {
  // 		headers = headers.set('Authorization', this.authService.token);
  // 		headers = headers.set('Access-Control-Expose-Headers', 'Authorization');
  // 	}
  //     headers = headers.set('X-Timezone-Offset', this.getTimezoneOffset());
  // 	return this.http.post(url, params, {headers, responseType:'text'})
  // 		.map(this.extractDataSSO.bind(this))
  // 		.catch(this.handleError.bind(this));
  // }

  postSSO(url: string, params: any): Observable<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }

    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    return this.http
      .post(url, params, { headers, responseType: "text" })
      .pipe(
        map(this.extractDataSSO.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  // postSSO2(url, params): Observable<any> {
  // 	let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  // 	if (this.authService.token) {
  // 		headers = headers.set('Authorization', this.authService.token);
  // 		headers = headers.set('Access-Control-Expose-Headers', 'Authorization');
  // 	}
  // 	return this.http.post(url, params, {headers, responseType:'text'})
  // 		.map(this.extractDataSSO.bind(this))
  // 		.catch(this.handleError.bind(this));
  // }

  postSSO2(url: string, params: any): Observable<any> {
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }

    return this.http
      .post(url, params, { headers, responseType: "text" })
      .pipe(
        map(this.extractDataSSO.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postMultiPart(url, data, params): Observable<any> {
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers, params: params };

    return this.http
      .post(url, data, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postEtimTransfer(url, data, params): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers, params: params };

    return this.http
      .post(url, data, options)
      .map(this.extractData.bind(this))
      .catch(this.handleError.bind(this));
  }

  postWithApplicationCustomHeader(url, body): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    if (body["userId"]) {
    }
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      userid: body["userId"],
    });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers, body: body };

    return this.http
      .post(url, {}, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postWithApplicationCustomHeader2(url, body): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    if (body["userId"]) {
    }
    let headers = new HttpHeaders({
      "Content-Type": "application/json",
      userid: body["userId"],
    });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    let options = { headers: headers, body: body };

    return this.http
      .post(url, {}, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postBulkData(url, data): Observable<any> {
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    return this.http
      .post(url, data, { headers: headers, responseType: "blob" })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleFileError.bind(this))
      );
  }

  postBulkDutyData(url, data): Observable<any> {
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());

    return this.http
      .post(url, data, { headers: headers })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  put(url, data): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers };

    return this.http
      .put(url, data, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  uploadFileToS3(file: File, url: string): Observable<any> {
    const headers = new HttpHeaders({ "Content-Type": file.type});
    return this.http.put(url, file, {headers, responseType : 'text'})
    .pipe(
      map(this.extractData.bind(this)),
      catchError(this.handleError.bind(this))
    );
  }


  putUpdatedData(url, data,params): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers, params: params };

    return this.http
      .put(url, data, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postWithApplication(url, body, params = null): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    //let options = { headers: headers};

    return this.http
      .post(url, body, { headers, params })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postWithApplication2(url, body): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    //let options = { headers: headers};

    return this.http
      .post(url, body, { headers })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postWithBest(url, body): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    let headers = new HttpHeaders();
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    // if (this.authService.token) {
    // 	headers = headers.set('Authorization', this.authService.token);
    // 	headers = headers.set('Access-Control-Expose-Headers', 'Authorization');
    // }
    //let options = { headers: headers};

    return this.http
      .post(url, body, { headers })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postWithBest2(url, body): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    let headers = new HttpHeaders();
    // if (this.authService.token) {
    // 	headers = headers.set('Authorization', this.authService.token);
    // 	headers = headers.set('Access-Control-Expose-Headers', 'Authorization');
    // }
    //let options = { headers: headers};

    return this.http
      .post(url, body, { headers })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postAfterCollection(url, body): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers.set("Authorization", this.authService.token);
      headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers, body: body };

    return this.http
      .post(url, {}, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  updateMobileNo(url, body): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers.set("Authorization", this.authService.token);
      headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers, body: body };

    return this.http
      .post(url, {}, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  getMobileVerify(url, params, responseType?: any): Observable<any> {
    //debugger;
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers.append("Authorization", this.authService.token);
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    if (params == null) {
      return this.http
        .get(url, { headers: headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .get(url, { params, headers: headers, responseType: responseType })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }

  /**
   * @description extracts the data from observable
   * @param res Response of http
   * @returns {any|{}} return body if null returns blank object
   */
  private extractData(res: any) {
    let body = res;
    return body || {};
  }

  private extractDataSSO(res: any) {
    let body = res;
    return body || {};
  }

  // /**
  //  * In case of error in http it's get called to handle error throws error Observable
  //  * @param error error response
  //  * @returns {ErrorObservable}
  //  */

  private handleError(error: Response | any): Observable<any> {
    let errMsg: string;
    let body;
    if (error) {
      // debugger
      try {
        if (error.status == 401 || error.status == 403) {
          if (this.refreshTokenInProgress) {
            return this.refreshTokenSubject.pipe(
              filter((result) => result !== null),
              take(1),
              switchMap(() => this.addAuthenticationToken(error.url)),
              retry(1) // retry the request once after refreshing the token
            );
          } else {
            this.refreshTokenInProgress = true;
            this.refreshTokenSubject.next(null);
            return this.refreshAccessToken().pipe(
              catchError((error: HttpErrorResponse) => {
                if (error) {
                  this.logOut();
                }
                return observableThrowError(error);
              }),
              switchMap((success: any) => {
                const rawToken = success.access_token;
                const decodedToken = jwt_decode(rawToken);
                this.authService.saveValue(
                  "refresh_token",
                  success.refresh_token
                );
                this.authService.saveValue(
                  "expirationTime",
                  decodedToken.exp.toString()
                );
                this.authService.saveValue("Authorization", rawToken);
                this.authService.token = rawToken;
                this.authService.saveValue("new", 1);
                // return this.authService.updateLogin(true, user, success).pipe(
                // 	switchMap((saved) => {
                this.refreshTokenSubject.next(success);
                return this.addAuthenticationToken(error.url);
                // 	})
                // );
              }),
              finalize(() => (this.refreshTokenInProgress = false))
              // retry(1), // retry the request once after refreshing the token
            );
          }
		} else if(error.status == 406){
			body = error.error || "";
			body.status = error.status;
			body.code = body.error;
			body.source = "AFCS_BACKEND";
			const err = JSON.stringify(body);
            errMsg = `${err}`;
		} else {
          body = error.error || "";
          body.status = error.status;
          const err = JSON.stringify(body);
          errMsg = `${err}`;
        }
      } catch (err) {
        errMsg = DataConfig.exceptionMessage;
      }
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return observableThrowError(errMsg);
  }

  private handleFileError(error: HttpErrorResponse): Observable<never> {
    if (error.error instanceof Blob) {
      // Convert the Blob error to JSON or text
      return new Observable(observer => {
        const reader = new FileReader();
        reader.onload = (e: Event) => {
          try {
            const errMsg = JSON.parse((e.target as FileReader).result as string);
            observer.error(errMsg);
          } catch (e) {
            observer.error((e.target as FileReader).result);
          }
        };
        reader.onerror = () => {
          observer.error('Error reading the error blob');
        };
        reader.readAsText(error.error);
      });
    } else {
      // Handle non-blob errors
      return observableThrowError(error.message || 'Server error');
    }
  }

  private addAuthenticationToken(url: string): Observable<any> {
    const accessToken = this.authService.token;
    if (accessToken) {
      const request = new HttpRequest("GET", url, {
        headers: new HttpHeaders().set("Authorization", `${accessToken}`),
        reportProgress: true,
      });
      return this.http.request(request);
    }
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    return this.http
      .get(url, { headers: headers })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  private refreshAccessToken(): Observable<any> {
    const refresh_token = this.authService.getValueForKey("refresh_token");
    return this.googleLoginService.getUserTokenFromRefreshToken(refresh_token);
  }

  /**
   *  Make an api call for delete stats from the url
   *@returns {Observable<R>} returns Observable
   */
  delete(url, params): Observable<any> {
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.append("Authorization", this.authService.token);
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    if (params == null) {
      return this.http
        .delete(url, { headers: headers })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    } else {
      return this.http
        .delete(url, { params, headers: headers })
        .pipe(
          map(this.extractData.bind(this)),
          catchError(this.handleError.bind(this))
        );
    }
  }

  postMultiPartCrew(url, data): Observable<any> {
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers.set("Authorization", this.authService.token);
      headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let res = "blob";
    let req: Object = {
      /* other options here */
      headers: headers,
      responseType: Blob,
    };

    // let options = new RequestOptions({ headers: headers});
    return this.http
      .post(url, data, req)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }
  postCrewBulk(url, data, params): Observable<any> {
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers.set("Authorization", this.authService.token);
      headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    let options = { headers: headers, search: params };

    return this.http
      .post(url, data, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  getCities() {
    let url = Urls.final_url + "dashboard/city";
    let params = null;
    params = new HttpParams();
    params = params.set("page", "" + 0);
    params = params.set("size", "" + 10000);
    params = params.set("search", "");
    this.get3(url, params).subscribe(
      (cities: any) => {
        if (cities && cities.content) {
          this.cities.length = 0;
          //pushing instead of assigning because we need the reference in other components
          this.cities.push(...cities.content);
        }
      },
      (error) => {
        this.cities.length = 0;
      }
    );
  }

  private getTimezoneOffset(): string {
    if (this.authService.userDetail.cityName == "SuperCity") {
      return String(new Date().getTimezoneOffset() * -1);
    }
    if (this.authService.userDetail.rolename === 'Bus Station Master' || this.authService.userDetail.rolename === 'Bus Station Admin') {
      return String(new Date().getTimezoneOffset() * -1);
      
    }

    let obj = [];
    if (!this.authService.userDetail?.regionalRole) {
      obj = this.cities.filter((item) => {
        return (
          item["cityName"].toLowerCase() ==
          this.authService.userDetail.cityName.toLowerCase()
        );
      });
    }
    if (obj.length == 0) {
      return String(new Date().getTimezoneOffset() * -1);
    }

    let str = "";
    if (obj[0]) {
      str = obj[0]["timezoneConfig"]["isoTimeZone"];
    }
    let hrs = str.substring(4, 6);
    let mins = str.substring(7);
    let offset = parseInt(hrs) * 60 + parseInt(mins);
    if (str[3] == "-") {
      offset = offset * -1;
    }

    return String(offset);
  }

  private logOut() {
    const UserID = this.authService.userDetail.userId;
    // this.signOut(UserID).subscribe(() => {
    // 	this.googleLoginService.updateUserState();
    // 	//to do clean the local-storage
    // 	this.authService.updateLogin(false, null).subscribe(() => {
    // 		this._localStorage.clearLocalStorage();
    // 		let redirect = `/${routePaths.login}`;
    // 		this.router.navigate([redirect]);
    // 	});
    // });
    this.googleLoginService.updateUserState();
    // 	//to do clean the local-storage
    this.authService.updateLogin(false, null).subscribe(() => {
      this._localStorage.clearLocalStorage();
      let redirect = `/${routePaths.login}`;
      this.router.navigate([redirect]);
    });
  }

  signOut(userId): Observable<any> {
    //logdebugger
    let url = googleConfig.logout.logoutUrl;
    let params = new HttpParams();
    params = params.append("userId", userId);
    return this.postSSO2(url, params);
  }


  /**
   *  Make an api call for fetching stats from the url
   *@returns {Observable<R>} returns Observable
   */
  getFileContent(url, params, responseType?: any,isHeadersRequired:boolean=false): Observable<any> {
    //debugger
    let headers = new HttpHeaders();
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    const options: any = { headers, responseType: responseType };
    if (params) {
      options.params = params;
    }
    if (isHeadersRequired) {
      options.observe = 'response';
    }
    return this.http
      .get(url, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(params ?   this.handleError.bind(this):this.parseErrorBlob)
      );
  }

  /**
   *  Make an api call for posting data to the url
   *@returns {Observable<R>} returns Observable
   */
  postFileContentWithParams(url, body, params?: any, responseType?: any, isHeadersRequired: boolean = false): Observable<any> {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    const options: any = { headers, responseType: responseType };
    if (params) {
      options.params = params;
    }
    if (isHeadersRequired) {
      options.observe = 'response';
    }
    return this.http
      .post(url, body, options)
      .pipe(
        map(this.extractData.bind(this)),
        catchError(params ? this.handleError.bind(this) : this.parseErrorBlob)
      );
  }
  
  postFileContent(url, body,params?:any): Observable<any> {
    // must to add body in requestOptions, not able to read from body on backend
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.authService.token) {
      headers = headers.set("Authorization", this.authService.token);
      headers = headers.set("Access-Control-Expose-Headers", "Authorization");
    }
    headers = headers.set("X-Timezone-Offset", this.getTimezoneOffset());
    //let options = { headers: headers};

    return this.http
      .post(url, body, { headers, responseType: "blob" })
      .pipe(
        map(this.extractData.bind(this)),
        catchError(this.handleError.bind(this))
      );
  }

  postStreamedFileContent(url, body): Observable<void> {
    return new Observable(observer => {
      let headers = new Headers({
        "Content-Type": "application/json",
        "Authorization": this.authService.token,
        "Access-Control-Expose-Headers": "Authorization",
        "X-Timezone-Offset": this.getTimezoneOffset()
      });
      const timeoutDuration = 2 * 60 * 1000; // 2 minutes in milliseconds
      let timeoutId: any;
      fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
      })
      .then(response => {
        if (!response.ok) {
          observer.error(`Error ${response.status}: ${response.statusText}`);
          return;
        }
        // Set a 2-minute timeout
        timeoutId = setTimeout(() => {
          observer.error('Timeout: The server took too long to send the file.');
        }, timeoutDuration);

      // Create a stream to read the response data
      const reader = response.body?.getReader();
      const chunks: Uint8Array[] = [];

      return reader?.read().then(function processChunk({ done, value }): any {
        if (done) {
          // Clear the timeout once we finish reading
          clearTimeout(timeoutId);

          // Combine all chunks into a single Blob and convert it to text to check for errors
          const blob = new Blob(chunks, { type: 'text/csv' });
          return blob.text().then(text => {
            // Split the text by newlines to check the last line
            const lines = text.trim().split('\n');
            const lastLine = lines[lines.length - 1];

            // Check if the last line starts with "error"
            if (lastLine.toLowerCase().startsWith("error")) {
              observer.error("Error: There was an issue on the server.");
              return;
            }

            // If no error, proceed with downloading the file
            const url = window.URL.createObjectURL(blob);
            const tempLink = document.createElement('a');
            tempLink.href = url;
            tempLink.setAttribute('download', 'waybillsignoff.csv');
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            observer.next();
            observer.complete();
          });
        }

        // Reset the timeout on each new chunk to ensure the server is still responsive
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          observer.error('Timeout: The server took too long to send the file.');
        }, timeoutDuration);

        // Add the current chunk to the list of chunks
        chunks.push(value);
        return reader?.read().then(processChunk);
      });
    })
    .catch(error => {
      clearTimeout(timeoutId);
      observer.error(error);
    });
    });
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    if (err.error instanceof Blob) {
      const reader: any = new FileReader();

      const obs = new Observable((observer: any) => {
        reader.onloadend = () => {
          try {
            const parsedError = JSON.parse(reader.result);
            observer.error(parsedError);
          } catch (error) {
            observer.error({ message: "Error parsing JSON response" });
          }
          observer.complete();
        };
      });

      reader.readAsText(err.error);

      return obs;
    } else {
      // Handle the case where the error is not a blob (e.g., it's a regular JSON response)
      return new Observable((observer: any) => {
        observer.error(err.error);
        observer.complete();
      });
    }
  }
  // });
}//service-closes